import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SiteSelectorEffects } from './effects';
import { SiteSelectorRoutingModule } from './site-selector-routing.module';

@NgModule({
  imports: [SiteSelectorRoutingModule, EffectsModule.forFeature([SiteSelectorEffects])],
})
export class SiteSelectorModule {}
